if (!customElements.get('bai-bundle')) {
  customElements.define('bai-bundle', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-bundle-submit]');
      this.label = this.button.textContent;
      this.selects = [...this.querySelectorAll('[data-bundle-extra]')];
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:this.dataset.currency});
      this.selects.forEach(select => { select.disabled = false; });
      this.button.disabled = !this.config.available;
      this.directButtons = [...this.closest('.shopify-section').querySelectorAll('[data-bai-machine-buy]')];
      this.directBuy = () => this.button.click();
      this.directButtons.forEach(button => {button.disabled = !this.config.available;button.addEventListener('click',this.directBuy);});
      this.update = () => {
        const unit = this.config.machinePrice + this.selects.reduce((sum, select) => sum + Number(select.selectedOptions[0].dataset.price || 0), 0);
        this.total = unit;
        this.querySelectorAll('[data-bai-gross]').forEach(el => {el.textContent = this.money.format(this.total / 100);});
        this.querySelectorAll('[data-bai-net]').forEach(el => {el.textContent = this.money.format(Math.round(this.total / 1.2) / 100);});
        const main = this.closest('.shopify-section');
        main?.querySelectorAll('.product-detail__price [data-bai-gross]').forEach(el => {el.textContent = this.money.format(this.total / 100);});
        main?.querySelectorAll('.product-detail__price [data-bai-net]').forEach(el => {el.textContent = this.money.format(Math.round(this.total / 1.2) / 100);});
        main?.querySelectorAll('[data-bai-payment-quote]').forEach(el => {el.hidden = this.selects.some(select => Boolean(select.value));});
        document.dispatchEvent(new CustomEvent('bai:bundle-change'));
      };
      this.submit = async event => {
        event.preventDefault();
        if (this.busy || !this.config.available || !this.form.reportValidity()) return;
        const quantity = 1;
        const properties = {'BAi bundle':this.config.title};
        const selected = this.selects.filter(select => select.value);
        const machineProperties = {...properties};
        this.selects.forEach(select => {machineProperties[select.previousElementSibling.textContent.trim()] = select.selectedOptions[0].dataset.name || select.selectedOptions[0].textContent.trim();});
        const items = [{id:this.config.machineId,quantity,properties:machineProperties},...selected.map(select => ({id:Number(select.value),quantity,properties}))];
        this.busy = true;
        this.button.disabled = true;
        this.directButtons.forEach(button => {button.disabled = true;button.setAttribute('aria-busy','true');});
        this.button.textContent = this.config.adding;
        this.button.setAttribute('aria-busy','true');
        this.querySelector('[data-bundle-error]').hidden = true;
        document.dispatchEvent(new CustomEvent('bai:bundle-change'));
        try {
          const response = await fetch(this.config.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.config.error);
          window.location.assign(this.config.cartUrl);
        } catch (error) {
          const message = this.querySelector('[data-bundle-error]');
          message.textContent = error.message || this.config.error;
          message.hidden = false;
          this.busy = false;
          this.button.disabled = !this.config.available;
          this.directButtons.forEach(button => {button.disabled = !this.config.available;button.removeAttribute('aria-busy');});
          this.button.textContent = this.label;
          this.button.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('bai:bundle-change'));
        }
      };
      this.form.addEventListener('input',this.update);
      this.form.addEventListener('change',this.update);
      this.form.addEventListener('submit',this.submit);
      this.update();
    }
    disconnectedCallback() {
      this.directButtons?.forEach(button => button.removeEventListener('click',this.directBuy));
      this.form?.removeEventListener('input',this.update);
      this.form?.removeEventListener('change',this.update);
      this.form?.removeEventListener('submit',this.submit);
    }
  });
}
